import React from 'react'
import { DesignedModal, Button } from '@clickcease/cc-client-components-lib'
import { Trans, useTranslation } from 'react-i18next'
import {
  ContactSupport,
  StyledLink,
  BoldText,
  styleReset,
} from '../Modals/CancelModal/CancelModal.styled'
import { StringMap } from 'i18next'

export const ExtendTrialModal = ({
  isOpen,
  setIsOpen,
  onConfirm,
  onCancelAccount,
  loading,
}: {
  isOpen: boolean
  setIsOpen: (val: boolean) => void
  onConfirm: () => void
  onCancelAccount: () => void
  loading?: boolean
}) => {
  const { t } = useTranslation('accountSettings')

  const translate = (key: string, options?: StringMap) =>
    t(`plan_details.extend_trial_modal.${key}`, options)

  return (
    <DesignedModal
      isOpen={isOpen}
      title={translate('title')}
      loading={loading}
      onOpenChange={setIsOpen}
      actions={
        <>
          <Button text={translate('secondary_button')} variant="ghost" onClick={onCancelAccount} />
          <Button text={translate('primary_button')} onClick={onConfirm} />
        </>
      }
    >
      <ContactSupport>
        <Trans
          t={t}
          i18nKey="plan_details.extend_trial_modal.schedule_call_text"
          components={{
            1: (
              <StyledLink
                href="https://calendly.com/cheq-essentials/onboarding-video-call"
                target="_blank"
                style={styleReset}
              />
            ),
            2: <BoldText />,
          }}
        />
      </ContactSupport>

      <ContactSupport>
        <Trans
          t={t}
          i18nKey="plan_details.extend_trial_modal.extend_trial"
          components={{
            1: <BoldText />,
          }}
        />
      </ContactSupport>
    </DesignedModal>
  )
}
